import React from 'react'
import "./About.scss";
import { motion } from "framer-motion";
import { urlFor, client } from "../../client/client";
import { AppWrap } from "../../wrapper";
const About = () => {

  const [abouts, setAbouts] = React.useState([]);
  React.useEffect(() => {
    const query = '*[_type=="abouts"]';
    client.fetch(query).then((data) => {
      //console.table(data);
      setAbouts(data);
    }).catch(() => {

    })
  }, [])
  // const abouts = [
  //   { title: "Dynamics 365", description: "I'm a good Dynamics 365 Developer", imgUrl: images.dynamics },
  //   { title: "Web Developer", description: "I'm a good Web Developer", imgUrl: images.web },
  //   { title: "Android Developer", description: "I'm a good Android Developer", imgUrl: images.about03 },
  //   { title: "Front End Developer", description: "I'm a good Front End Developer", imgUrl: images.about04 },
  // ];
  return (
    <>
      <h2 className='head-text app_description'>I am a  <span>.NetDeveloper </span>
        (C# , MVC , Xamarin , AndroidStudio ,
        TypeScript , Dynamics365 , Power Apps Control Framework ,
        Microsoft Flow, Azure) <br></br>
        with experience of working on a variety of <span> web development </span> and ,<span> mobile based</span>
        projects. I work on all aspects of the development life cycle, applying my knowledge of  <span>OOP</span> and <span> MVC </span>
        principles</h2>
      <div className='app__profiles '>
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 1, type: "tween" }}
            className="app__profile-item"
            key={`${about.title}-${index}`}
          >
            <img src={urlFor(about.imgUrl).width(200).url()} alt={about.title} ></img>
            <h2 className='bold-text' style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(About, "about");